(function() {
  var nav = document.querySelector("[data-msb-paginate]");
  if (!nav) return;
  var grid = document.querySelector(".msb-grid");
  if (!grid) return;
  var perPage = parseInt(nav.getAttribute("data-msb-paginate"), 10) || 9;
  var cards = Array.prototype.slice.call(grid.children);
  var pages = Math.ceil(cards.length / perPage);
  if (pages < 2) return;
  var current = 1;
  function button(label, page, cls) {
    var b = document.createElement("button");
    b.type = "button";
    b.textContent = label;
    if (cls) b.className = cls;
    if (page) b.addEventListener("click", function() {
      go(page);
    });
    return b;
  }
  function numbers() {
    var out = [], i;
    for (i = 1; i <= pages; i++) {
      if (i === 1 || i === pages || i >= current - 1 && i <= current + 1) out.push(i);
      else if (out[out.length - 1] !== "\u2026") out.push("\u2026");
    }
    return out;
  }
  function render() {
    nav.textContent = "";
    if (current > 1) {
      var prev = button("\u2190", current - 1, "prev");
      prev.setAttribute("aria-label", "Previous page");
      nav.appendChild(prev);
    }
    numbers().forEach(function(n) {
      if (n === "\u2026") {
        var gap = document.createElement("span");
        gap.className = "gap";
        gap.textContent = "\u2026";
        gap.setAttribute("aria-hidden", "true");
        nav.appendChild(gap);
        return;
      }
      var b = button(String(n), n);
      b.setAttribute("aria-label", "Page " + n);
      if (n === current) b.setAttribute("aria-current", "page");
      nav.appendChild(b);
    });
    if (current < pages) {
      var next = button("\u2192", current + 1, "next");
      next.setAttribute("aria-label", "Next page");
      nav.appendChild(next);
    }
  }
  function go(page) {
    current = page;
    cards.forEach(function(card, i) {
      var on = i >= (page - 1) * perPage && i < page * perPage;
      card.hidden = !on;
    });
    render();
    if (grid.getBoundingClientRect().top < 0) {
      grid.scrollIntoView({ block: "start" });
    }
  }
  nav.setAttribute("aria-live", "polite");
  go(1);
})();
(function() {
  var scope = document.querySelector(".msb");
  if (!scope) return;
  function gap() {
    var v = getComputedStyle(scope).getPropertyValue("--msb-sticky-gap").trim();
    if (!v) return 32;
    var probe = document.createElement("div");
    probe.style.cssText = "position:absolute;visibility:hidden;height:" + v;
    scope.appendChild(probe);
    var px = probe.getBoundingClientRect().height;
    probe.remove();
    return px || 32;
  }
  function measure() {
    var lowest = 0;
    var nodes = document.body.querySelectorAll('header, [class*="header"], [class*="nav"], [class*="topbar"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cs = getComputedStyle(el);
      if (cs.position !== "sticky" && cs.position !== "fixed") continue;
      var r = el.getBoundingClientRect();
      if (r.top > 120 || r.height < 20 || r.height > 240) continue;
      if (r.bottom > lowest) lowest = r.bottom;
    }
    if (lowest > 0) scope.style.setProperty("--msb-sticky-top", Math.round(lowest + gap()) + "px");
  }
  measure();
  window.addEventListener("resize", measure);
  window.addEventListener("load", measure);
})();
(function() {
  var list = document.querySelector(".msb-toc ol");
  if (!list) return;
  if (!list.querySelector("a")) {
    var found = document.querySelectorAll(".msb-body h2, .msb-article h2");
    found = Array.prototype.filter.call(found, function(h) {
      return h.textContent.trim().length > 0;
    });
    found.forEach(function(h, i) {
      if (!h.id) {
        h.id = "section-" + (i + 1) + "-" + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40).replace(/-+$/, "");
      }
    });
    if (found.length < 2) {
      var aside = document.querySelector(".msb-toc");
      if (aside && aside.parentNode) {
        var side = aside.closest(".msb-side");
        aside.parentNode.removeChild(aside);
        if (side && side.parentNode && !side.querySelector(".msb-sideproducts")) side.parentNode.removeChild(side);
      }
      return;
    }
    found.forEach(function(h) {
      var li = document.createElement("li");
      var a = document.createElement("a");
      a.href = "#" + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
  }
  var links = list.querySelectorAll("a");
  if (!links.length) return;
  var toggle = document.querySelector(".msb-toc .toggle");
  var inline = false;
  function syncCollapse() {
    inline = !!toggle && toggle.offsetParent !== null;
    list.hidden = inline && toggle.getAttribute("aria-expanded") !== "true";
  }
  if (toggle) {
    toggle.addEventListener("click", function() {
      var open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      list.hidden = open;
    });
  }
  syncCollapse();
  window.addEventListener("resize", syncCollapse, { passive: true });
  (function() {
    function setActive(id) {
      var target = null;
      links.forEach(function(a) {
        var on = a.getAttribute("href") === "#" + id;
        a.classList.toggle("active", on);
        if (on) target = a;
      });
      if (target) {
        list.style.setProperty("--toc-marker-y", target.offsetTop + "px");
        var full = list.offsetHeight || 1;
        list.style.setProperty("--toc-marker-scale", (target.offsetHeight / full).toString());
      }
    }
    var heads = [];
    links.forEach(function(a) {
      var el = document.getElementById(a.getAttribute("href").slice(1));
      if (el) heads.push(el);
    });
    if (!heads.length) return;
    var line = function() {
      return window.innerHeight * 0.3;
    };
    function update() {
      if (inline) return;
      var edge = line();
      var current = heads[0].id;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top <= edge) current = heads[i].id;
      }
      setActive(current);
    }
    var ticking = false;
    window.addEventListener("scroll", function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        update();
        ticking = false;
      });
    }, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
  })();
})();
(function() {
  var tables = document.querySelectorAll(".msb-body table");
  Array.prototype.forEach.call(tables, function(t) {
    if (t.closest(".msb-table, .msb-scroll")) return;
    var box = document.createElement("div");
    box.className = "msb-scroll";
    t.parentNode.insertBefore(box, t);
    box.appendChild(t);
  });
})();
(function() {
  var buttons = document.querySelectorAll("[data-msb-copy]");
  buttons.forEach(function(b) {
    b.addEventListener("click", function() {
      var raw = b.getAttribute("data-msb-copy") || location.href;
      var value = raw.indexOf("http") === 0 ? raw : location.origin + raw;
      function confirmCopied() {
        b.classList.add("copied");
        var had = b.getAttribute("aria-label");
        b.setAttribute("aria-label", "Link copied");
        setTimeout(function() {
          b.classList.remove("copied");
          if (had) b.setAttribute("aria-label", had);
        }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(confirmCopied).catch(function() {
        });
      } else {
        var f = document.createElement("textarea");
        f.value = value;
        f.setAttribute("readonly", "");
        f.style.cssText = "position:absolute;left:-9999px";
        document.body.appendChild(f);
        f.select();
        try {
          document.execCommand("copy");
          confirmCopied();
        } catch (e) {
        }
        f.remove();
      }
    });
  });
})();
(function() {
  var form = document.querySelector(".msb-search");
  if (!form) return;
  var input = form.querySelector('input[type="search"]');
  if (!input) return;
  var box = document.createElement("div");
  box.className = "results";
  box.setAttribute("role", "listbox");
  box.hidden = true;
  form.appendChild(box);
  function close() {
    box.hidden = true;
    box.innerHTML = "";
  }
  function render(articles) {
    box.innerHTML = "";
    if (!articles.length) {
      var none = document.createElement("p");
      none.className = "none";
      none.textContent = "No matching posts";
      box.appendChild(none);
    } else {
      articles.slice(0, 5).forEach(function(a) {
        var link = document.createElement("a");
        link.href = a.url;
        link.setAttribute("role", "option");
        if (a.image) {
          var img = document.createElement("img");
          img.src = a.image;
          img.alt = "";
          img.loading = "lazy";
          link.appendChild(img);
        }
        var label = document.createElement("span");
        label.textContent = a.title;
        link.appendChild(label);
        box.appendChild(link);
      });
    }
    box.hidden = false;
  }
  var timer = null;
  var seq = 0;
  input.addEventListener("input", function() {
    var q = input.value.trim();
    if (timer) clearTimeout(timer);
    if (q.length < 2) {
      close();
      return;
    }
    timer = setTimeout(function() {
      var mine = ++seq;
      var base = (form.getAttribute("action") || "/search").replace(/\/$/, "");
      var url = base + "/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=article&resources[limit]=5";
      fetch(url).then(function(r) {
        return r.json();
      }).then(function(data) {
        if (mine !== seq) return;
        var results = ((data || {}).resources || {}).results || {};
        render(results.articles || []);
      }).catch(function() {
        close();
      });
    }, 200);
  });
  input.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      close();
      input.blur();
    }
  });
  document.addEventListener("click", function(e) {
    if (!form.contains(e.target)) close();
  });
})();
(function() {
  var HEADING = /\b(key takeaways?|the short version|in short|tl;?dr)\b/i;
  var body = document.querySelector(".msb-body");
  if (!body) return;
  if (body.querySelector(".msb-takeaways")) return;
  var paras = body.querySelectorAll(":scope > p");
  for (var i = 0; i < paras.length; i++) {
    var p = paras[i];
    var label = p.textContent || "";
    if (!HEADING.test(label)) continue;
    var strong = p.querySelector("strong, b");
    if (!strong) continue;
    if (strong.textContent.trim() !== label.trim()) continue;
    if (label.trim().length > 40) continue;
    var list = p.nextElementSibling;
    if (!list) continue;
    if (list.tagName !== "UL" && list.tagName !== "OL") continue;
    var aside = document.createElement("aside");
    aside.className = "msb-takeaways";
    var h2 = document.createElement("h2");
    h2.textContent = label.trim().replace(/:$/, "");
    p.parentNode.insertBefore(aside, p);
    aside.appendChild(h2);
    aside.appendChild(list);
    p.parentNode.removeChild(p);
    return;
  }
})();
(function() {
  var side = document.querySelector(".msb-sideproducts");
  if (!side) return;
  var scope = document.querySelector(".msb") || document.documentElement;
  var rail = document.querySelector(".msb-toc");
  function set() {
    var live = rail && rail.parentNode ? rail : null;
    var h = live ? Math.round(live.getBoundingClientRect().height) : 0;
    scope.style.setProperty("--msb-toc-h", h + "px");
  }
  set();
  if (rail && window.ResizeObserver) new ResizeObserver(set).observe(rail);
  window.addEventListener("load", set);
  window.addEventListener("resize", set);
})();
(function() {
  var theme = window.Shopify && window.Shopify.theme;
  if (!theme || theme.role === "main") return;
  var root = document.querySelector(".msb");
  if (!root) return;
  root.addEventListener("click", function(event) {
    var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    if (!link || link.target === "_blank") return;
    var url;
    try {
      url = new URL(link.getAttribute("href"), location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== location.origin || url.searchParams.has("view")) return;
    var view = /^\/blogs\//.test(url.pathname) ? "mentionstack" : /^\/pages\//.test(url.pathname) && link.closest(".msb-byline, .msb-author, .msb-related, .msb-card") ? "mentionstack-author" : "";
    if (!view) return;
    url.searchParams.set("view", view);
    link.setAttribute("href", url.pathname + url.search + url.hash);
  }, true);
})();
